/* Build Your Set — one colour for the whole set, a size per piece, one add-to-cart request.
   Options are matched by NAME ("Colour"/"Color", "Size"), so option order doesn't matter. */
(function () {
  function findIndexBy(names, re) {
    for (var i = 0; i < names.length; i++) if (re.test(names[i])) return i;
    return -1;
  }

  function init(root) {
    var COLOR_RE = /colo/i, SIZE_RE = /size/i;

    var pieces = Array.prototype.map.call(root.querySelectorAll('[data-bys-piece]'), function (el) {
      var names = [];
      try { names = JSON.parse(el.dataset.optionNames || '[]'); } catch (e) {}
      return {
        el: el,
        names: names,
        ci: findIndexBy(names, COLOR_RE),
        si: findIndexBy(names, SIZE_RE),
        variants: JSON.parse(el.querySelector('[data-bys-variants]').textContent),
        select: el.querySelector('[data-bys-size]'),
        thumb: el.querySelector('.bys__thumb'),
        thumbDefault: (el.querySelector('.bys__thumb') || {}).getAttribute
          ? el.querySelector('.bys__thumb').getAttribute('src') : null,
        toggle: el.querySelector('[data-bys-toggle]'),
        price: el.querySelector('[data-bys-price]'),
        status: el.querySelector('[data-bys-status]'),
        variant: null,
        selected: false
      };
    });

    var colorBtns = Array.prototype.slice.call(root.querySelectorAll('[data-bys-color]'));
    var addBtn = root.querySelector('[data-bys-add]');
    var countEl = root.querySelector('[data-bys-count]');
    var totalEl = root.querySelector('[data-bys-total]');
    var errEl = root.querySelector('[data-bys-error]');
    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    var color = colorBtns.length ? colorBtns[0].dataset.bysColor : null;

    var heroEl = root.querySelector('[data-bys-hero]');
    var heroDefault = heroEl ? heroEl.getAttribute('src') : null;
    var heroMap = {};
    (root.dataset.bysHeroes || '').split('~~').forEach(function (pair) {
      if (!pair) return;
      var bits = pair.split('::');
      if (bits.length === 2) heroMap[bits[0]] = bits[1];
    });

    function money(cents) {
      var parts = (cents / 100).toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, parts.join('.'));
    }

    function inColor(p, v) {
      return p.ci < 0 || !color || v.options[p.ci] === color;
    }

    function resolve() {
      var heroCandidate = null;

      pieces.forEach(function (p) {
        var pool = p.variants.filter(function (v) { return inColor(p, v); });
        if (!heroCandidate) {
          for (var h = 0; h < pool.length; h++) { if (pool[h].imageWide) { heroCandidate = pool[h].imageWide; break; } }
        }

        // sizes available in this colour
        if (p.select) {
          var wanted = p.select.value;
          var stillOk = false;
          Array.prototype.forEach.call(p.select.options, function (opt) {
            if (!opt.value) return;
            var ok = pool.some(function (v) { return v.options[p.si] === opt.value && v.available; });
            opt.disabled = !ok;
            if (ok && opt.value === wanted) stillOk = true;
          });
          if (wanted && !stillOk) p.select.value = '';
          p.select.disabled = pool.length === 0;
        }

        var size = p.select ? p.select.value : '';
        p.variant = null;
        if (pool.length) {
          if (p.si < 0) {
            p.variant = pool[0].available ? pool[0] : null;
          } else if (size) {
            for (var i = 0; i < pool.length; i++) {
              if (pool[i].options[p.si] === size) { p.variant = pool[i].available ? pool[i] : null; break; }
            }
          }
        }

        var unavailable = pool.length === 0;
        p.el.dataset.disabled = unavailable ? 'true' : 'false';
        p.toggle.disabled = unavailable;
        if (unavailable || !p.variant) {
          p.selected = false;
          p.el.dataset.selected = 'false';
          p.toggle.textContent = '+';
          p.toggle.setAttribute('aria-pressed', 'false');
        }

        p.status.textContent = unavailable
          ? 'Not available in ' + color
          : p.variant
            ? (color ? color + ' · in stock' : 'In stock')
            : size ? 'Sold out in ' + size
              : color ? color + ' · select a size' : 'Select a size';

        // show the chosen colour's photo
        if (p.thumb && p.thumb.tagName === 'IMG') {
          var shot = null;
          for (var n = 0; n < pool.length; n++) { if (pool[n].image) { shot = pool[n].image; break; } }
          if (!shot) shot = p.thumbDefault;
          if (shot && p.thumb.getAttribute('src') !== shot) {
            p.thumb.removeAttribute('srcset');
            p.thumb.setAttribute('src', shot);
          }
        }

        var priceSrc = p.variant || pool[0] || p.variants[0];
        if (priceSrc) p.price.textContent = priceSrc.priceFormatted;
      });
      if (heroEl) {
        var hero = (color && heroMap[color]) || heroCandidate || heroDefault;
        if (hero) {
          if (heroEl.getAttribute('src') !== hero) {
            heroEl.removeAttribute('srcset');
            heroEl.setAttribute('src', hero);
          }
          heroEl.hidden = false;
        }
      }

      sum();
    }

    function sum() {
      var chosen = pieces.filter(function (p) { return p.selected && p.variant; });
      var cents = chosen.reduce(function (t, p) { return t + p.variant.price; }, 0);
      countEl.textContent = chosen.length === 1 ? '1 piece selected' : chosen.length + ' pieces selected';
      totalEl.textContent = money(cents);
      addBtn.disabled = chosen.length === 0;
      addBtn.textContent = chosen.length > 1 ? 'Add ' + chosen.length + ' pieces to bag' : 'Add to bag';
    }

    var moreBtn = root.querySelector('[data-bys-more]');
    if (moreBtn) moreBtn.addEventListener('click', function () {
      var extras = root.querySelectorAll('[data-extra="true"]');
      var opening = moreBtn.getAttribute('aria-expanded') !== 'true';
      Array.prototype.forEach.call(extras, function (r) { r.hidden = !opening; });
      moreBtn.setAttribute('aria-expanded', String(opening));
      moreBtn.textContent = opening ? 'Show fewer −' : extras.length + ' more ' +
        (extras.length === 1 ? 'piece' : 'pieces') + ' in this set +';
    });

    colorBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        color = btn.dataset.bysColor;
        colorBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
        resolve();
      });
    });

    pieces.forEach(function (p) {
      if (p.select) p.select.addEventListener('change', function () {
        resolve();
        if (p.variant && !p.selected) p.toggle.click();
      });

      p.toggle.addEventListener('click', function () {
        if (!p.variant) {
          if (p.select && !p.select.value) { p.status.textContent = 'Select a size first'; p.select.focus(); }
          return;
        }
        p.selected = !p.selected;
        p.el.dataset.selected = p.selected ? 'true' : 'false';
        p.toggle.textContent = p.selected ? '\u2713' : '+';
        p.toggle.setAttribute('aria-pressed', String(p.selected));
        sum();
      });
    });

    addBtn.addEventListener('click', function () {
      var items = pieces
        .filter(function (p) { return p.selected && p.variant; })
        .map(function (p) { return { id: p.variant.id, quantity: 1 }; });
      if (!items.length) return;

      errEl.hidden = true;
      var label = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';

      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .then(function (data) {
          document.dispatchEvent(new CustomEvent('bys:added', { detail: data }));
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            drawer.open();
            addBtn.disabled = false;
            addBtn.textContent = label;
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function (e) {
          errEl.hidden = false;
          errEl.textContent = (e && e.description) || 'Something went wrong. Please try again.';
          addBtn.disabled = false;
          addBtn.textContent = label;
        });
    });

    resolve();
  }

  document.querySelectorAll('[data-bys]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-bys]').forEach(init);
  });
})();
